<template>
  <b-overlay :style="{ height: '100%' }" :variant="skin" :show="isLoading">
    <div class="mb-5" v-if="internalOptions">
      <b-row>
        <b-col cols="6">
          <b-form-group label="Escolha uma aula:">
            <v-select
              v-model="lesson"
              :options="internalOptions"
              autocomplete="off"
              :clearable="false"
              :disabled="!inputEnable(expectedPayloads[0])"
            />
          </b-form-group>
          <b-form-group label="Duração:" v-if="lesson && !rescheduling">
            <b-input-group>
              <flat-pickr
                v-model="lesson.details.duration"
                placeholder="Duração"
                class="form-control duration"
                :config="{
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: 'H:i',
                  time_24hr: true,
                }"
              />
              <b-input-group-append>
                <b-button variant="info" @click="changeDuration">
                  Alterar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group v-if="lesson && availableAcceptRecording">
            <div class="d-flex mt-1">
              <b-form-checkbox
                :class="
                  !lesson.accept_recording
                    ? 'custom-control-primary'
                    : 'custom-control-info'
                "
                v-model="lesson.accept_recording"
                switch
                :disabled="!inputEnable(expectedPayloads[2])"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
              <span>Aceita Material (Material Pendente)</span>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="c-footer d-block">
      <b-button
        :disabled="loading"
        :class="{ 'px-3': loading }"
        variant="info"
        @click="onClickSubmit"
      >
        <b-spinner v-if="loading" small />
        <span v-else>Próximo</span>
      </b-button>
    </div>
  </b-overlay>
</template>

<script>
import appConfig from "@core/app-config/useAppConfig";
import _lessonService from "@/services/lessons-service";
import { BFormGroup, BInputGroup, BSpinner } from "bootstrap-vue";

export default {
  setup() {
    const { skin } = appConfig();
    return {
      skin,
    };
  },
  components: {
    BFormGroup,
    BInputGroup,
    BSpinner,
  },
  data() {
    return {
      isLoading: false,
      lesson: null,
      internalOptions: null,
      availableAcceptRecording: false,
      expectedPayloads: ["selected_lesson", "duration", "accept_recording"],
      expectedOptions: ["lessons"],
      inputsEnabled: [],
    };
  },
  props: {
    loading: Boolean,
    rescheduling: Boolean,
    payload: Object,
    options: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.startComponent();
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleNextStepHotKey);
  },
  methods: {
    startComponent() {
      // verifica se foi possível lidar com o payload e as options
      if (this.checkOptions() && this.checkPayload()) {
        this.handleOptions();
        this.handlePayload();
      } else {
        this.emitError();
      }
      document.addEventListener("keyup", this.handleNextStepHotKey);
    },
    checkPayload() {
      if (this.$props.hasOwnProperty("payload") && this.payload) {
        // payload é opcional
        return this.expectedPayloads.every((key) => key in this.payload);
      }
      return true;
    },
    checkOptions() {
      return (
        this.$props.hasOwnProperty("options") &&
        this.options &&
        this.expectedOptions.every((key) => key in this.options) &&
        Array.isArray(this.options.lessons) &&
        this.options.lessons.length > 0 &&
        this.options.lessons.every(
          (t) =>
            t.hasOwnProperty("value") &&
            t.hasOwnProperty("label") &&
            t.hasOwnProperty("details")
        ) &&
        this.options.hasOwnProperty("available_accept_recording") &&
        this.options.hasOwnProperty("can_change")
      );
    },
    handlePayload() {
      if (this.$props.hasOwnProperty("payload") && this.payload) {
        this.lesson = this.internalOptions.find(
          (f) => f.value == this.payload.selected_lesson
        );
        this.lesson.accept_recording = this.payload.accept_recording;
      }
    },
    handleOptions() {
      this.internalOptions = this.options.lessons.map((option) => {
        return { ...option, accept_recording: false };
      });
      this.availableAcceptRecording = this.options.available_accept_recording;
      this.inputsEnabled = this.options.can_change;
    },
    handleResponse() {
      if (this.lesson) {
        let lesson = this.internalOptions.find(
          (f) => f.value == this.lesson.value
        );
        return {
          selected_lesson: lesson.value,
          duration: this.formatDuration(lesson.details.duration),
          accept_recording: lesson.accept_recording,
        };
      } else {
        this.$emit("warning", {
          type: "info",
          message: "Selecione uma Aula",
        });
        return null;
      }
    },
    onClickSubmit() {
      const payload = this.handleResponse();
      payload && this.$emit("submit", payload);
    },
    emitError() {
      this.$emit("error");
    },
    changeDuration() {
      this.$swal({
        title: "Alteração da duração",
        text: "A duração será alterada mesmo se não completar a marcação do agendamento, você deseja continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, quero continuar!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (result.isConfirmed) {
            this.saveDuration();
          }
        }
      });
    },
    saveDuration() {
      this.isLoading = true;
      const payload = [
        {
          path: "/duration",
          op: "replace",
          value: this.formatDuration(this.lesson.details.duration),
        },
      ];
      _lessonService
        .saveDuration(this.lesson.value, payload)
        .then((res) => {
          if (res.content) {
            const index = this.findIndexSelectedLesson();
            const duration = this.formatDuration(res.content.duration);
            this.internalOptions[index].details.duration = duration;
            this.$emit("warning", {
              type: "success",
              message: "Duração alterada com sucesso",
            });
          }
        })
        .catch((error) => {
          this.$emit("warning", {
            type: "danger",
            message:
              "Ocorreu um erro durante a alteração da duração. Por favor, entre em contato com o time de suporte.",
          });
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    findIndexSelectedLesson() {
      return this.internalOptions.findIndex(
        (f) => f.value == this.lesson.value
      );
    },
    formatDuration(duration) {
      if (duration && duration.length == 5) {
        return duration + ":00";
      } else {
        return duration;
      }
    },
    inputEnable(input) {
      return this.rescheduling ? this.inputsEnabled.some((s) => s == input) : true;
    },
    handleNextStepHotKey(event) {
      if (event.key.toLowerCase() === "p" && event.shiftKey && event.altKey) {
        this.onClickSubmit();
      }
    },
  },
};
</script>

<style scoped>
.duration {
  max-width: 100px;
}
.c-footer {
  position: absolute;
  bottom: 0px;
}
</style>